var Firebase = {
    UI_ERROR_EVENT: 'ui_error',
    DEDUP_WINDOW_MS: 5000,
    PARAM_MAX_LENGTH: 100,
    FINGERPRINT_PREFIX: 'ui_',
    FATAL_TRUE: 'true',
    FATAL_FALSE: 'false',
    SEND_PAGE_VIEW: false,
    PLATFORM: 'web'
};
export var FirebaseErrorSources = {
    ERROR_BOUNDARY: 'error_boundary',
    WINDOW_ONERROR: 'window_onerror',
    UNHANDLED_REJECTION: 'unhandledrejection'
};
export var FirebaseThirdPartyPattern = /cookieyes|googletagmanager|facebook|doubleclick|appboycdn|googleadservices|js\.appboycdn\.com|connect\.facebook\.net|cdn\./i;
// Stack frame "file:line:column". Groups: 1 file, 2 line, 3 column.
// e.g. "https://localhost/main.js:12:8"
export var FirebaseStackFrameLocation = /([^\s()]+):(\d+):(\d+)/;
export default Firebase;
